//@ts-strict-ignore
/*
 * Card Wrapper around Sales Invoice Analysis for display in Overviews (E.g. Customer Overview Tab).
 * */
import React, { ReactElement, useContext } from 'react';
import SalesInvoiceAnalysis, { ANALYTICS_REPORT_TYPES, ISalesInvoiceAnalysisProps } from './SalesInvoiceAnalysis';
import AppContext from '../../../components/Context/AppContext';
import OverviewCard from '../../../components/connectedForm/OverviewCard';

type ISalesInvoiceAnalysisCardProps = Omit<ISalesInvoiceAnalysisProps, 'reportType' | 'graphOnly' | 'graphHeight'> & {
  cardHeader: ReactElement;
  ready: boolean; //Render a placeholder until data from parent is ready, so we don't double up on queries unnecessarily.
};

const SalesInvoiceAnalysisCard = (props: ISalesInvoiceAnalysisCardProps) => {
  const { cardHeader, ready } = props;

  const app = useContext(AppContext);

  return (
    <OverviewCard>
      {cardHeader}
      {ready && !!app?.company ? (
        <SalesInvoiceAnalysis {...props} reportType={ANALYTICS_REPORT_TYPES[2]} graphOnly={true} graphHeight={200} />
      ) : (
        <div style={{ height: 200 }} />
      )}
    </OverviewCard>
  );
};

export default SalesInvoiceAnalysisCard;
